import { useEffect, useRef, useState } from 'react';
import { Images } from '../../assets';
import { Footer, Header } from '../../components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import 'swiper/css';
import styles from './style.module.scss';
import { Mousewheel } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';

const IMG_LIST = [
  Images.main1,
  Images.main2,
  Images.main3,
  Images.main4,
  Images.main5
];
const MOBILE_IMG_LIST = [
  Images.main_mobile_1,
  Images.main_mobile_2,
  Images.main_mobile_3,
  Images.main_mobile_4,
  Images.main_mobile_5
];

export default function Page() {
  const navigation = useNavigate();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const swiperRef = useRef<SwiperCore | null>(null);
  const lockRef = useRef(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imgList] = useState(
    window.innerWidth > 840 ? IMG_LIST : MOBILE_IMG_LIST
  );

  const goToPage = (pageIndex: number) => {
    swiperRef.current?.slideTo(pageIndex, 300);
  };

  const handleSlideChange = (swiper: SwiperCore) => {
    if (lockRef.current) return;

    lockRef.current = true;
    swiper.mousewheel?.disable(); // 휠 잠금

    setCurrentIndex(swiper.activeIndex);

    setTimeout(() => {
      swiper.mousewheel?.enable(); // 다시 활성화
      lockRef.current = false;
    }, swiper.params.speed); // animation 끝난 뒤
  };

  useEffect(() => {
    const redirect = new URLSearchParams(window.location.search).get(
      'redirect'
    );
    if (redirect) {
      navigation(redirect);
    }
  }, [navigation]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Header isBackground={false} />
      </div>
      <div ref={containerRef} className={styles.scrollContainer}>
        <Swiper
          direction="vertical"
          slidesPerView="auto"
          className={styles.swiperContainer}
          resistanceRatio={0}
          onSwiper={(swiper: SwiperCore) => {
            swiperRef.current = swiper;
            swiper.slideTo(currentIndex, 0);
          }}
          onSlideChange={handleSlideChange}
          speed={700}
          modules={[Mousewheel]}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1,
            thresholdDelta: 50,
            thresholdTime: 300
          }}
          longSwipesRatio={0.2}
          longSwipesMs={500}
          allowTouchMove={true}
        >
          {imgList.map((item, index) => {
            const isLast = index === imgList.length - 1;
            return (
              <SwiperSlide key={index}>
                <section
                  className={[
                    styles.slide,
                    isLast ? styles.last : undefined
                  ].join(' ')}
                >
                  <img
                    src={item}
                    alt={`ohu-image-${index + 1}`}
                    draggable={false}
                  />
                </section>
              </SwiperSlide>
            );
          })}
          <SwiperSlide>
            <Footer />
          </SwiperSlide>
        </Swiper>
        <div className={styles.pagination}>
          {IMG_LIST.map((_, index) => {
            const isActive = currentIndex === index;
            return (
              <span
                key={index}
                className={[styles.page, !!isActive && styles.active].join(' ')}
                onClick={() => goToPage(index)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
